import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentThreadUnarchived.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export const useTrackAgentThreadUnarchived = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentThreadUnarchived = useCallback(() => {
    track(META.name, withWorkspaceAgentCategory({}));
  }, [track]);

  return { trackAgentThreadUnarchived };
};
